import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader2, ArrowLeft } from "lucide-react";
import { Header } from "@/components/Header";
import { SiteFooter } from "@/components/SiteFooter";
import { CampaignDashboard } from "@/components/CampaignDashboard";
import { ManagedCampaignReport } from "@/components/client/ManagedCampaignReport";
import { getCampaign } from "@/lib/api";

export default function CampaignView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [kind, setKind] = useState(null);
  useEffect(() => { getCampaign(id).then((d) => setKind(d.kind || "legacy")).catch(() => setKind("legacy")); }, [id]);
  return (
    <div className="min-h-screen bg-[#E6EAEC] flex flex-col">
      <Header />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <Link to="/account" data-testid="back-to-account" className="inline-flex items-center gap-1.5 text-sm text-[#52525b] hover:text-[#09090b] mb-6">
          <ArrowLeft className="w-4 h-4" /> Le mie campagne
        </Link>
        {!kind && <Loader2 className="w-6 h-6 animate-spin text-[#E0262C]" />}
        {kind === "managed" && <ManagedCampaignReport id={id} />}
        {kind === "legacy" && <CampaignDashboard campaignId={id} onReset={() => navigate("/")} />}
      </section>
      <div className="mt-auto"><SiteFooter /></div>
    </div>
  );
}
